(() => {
  let bootstrap;
  function trustpilotReady() {
    if (window.Trustpilot?.loadFromElement) return Promise.resolve();
    if (bootstrap) return bootstrap;
    bootstrap = new Promise((resolve, reject) => {
      let attempts = 0;
      const poll = setInterval(() => {
        if (window.Trustpilot?.loadFromElement) { clearInterval(poll); resolve(); }
        else if (++attempts >= 100) { clearInterval(poll); reject(new Error('Trustpilot unavailable')); }
      }, 100);
      if (!document.querySelector('script[src*="widget.trustpilot.com/bootstrap/"]')) {
        const script = document.createElement('script');
        script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
        script.async = true;
        script.onerror = () => { clearInterval(poll); reject(new Error('Trustpilot unavailable')); };
        document.head.append(script);
      }
    });
    return bootstrap;
  }
  class ReviewsPage extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dataset.enhanced = 'true';
      this.groups = [...this.querySelectorAll('[data-reviews-rating]')];
      this.buttons = [...this.querySelectorAll('[data-rating]')];
      this.querySelector('.reviews-controls').hidden = false;
      this.onClick = event => {
        const button = event.target.closest('[data-rating]');
        if (!button || !this.contains(button)) return;
        const filter = button.dataset.rating;
        this.buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.groups.forEach(group => {
          const rating = group.dataset.reviewsRating;
          const visible = filter === 'positive' ? rating === '4' || rating === '5' : filter === 'all' ? rating !== 'recent' : rating === filter;
          group.hidden = !visible;
          if (!group.hidden && filter !== 'all') this.mount(group);
        });
        const scope = this.querySelector('[data-reviews-scope]');
        scope.hidden = filter === 'positive';
        scope.textContent = filter === 'positive' ? '' : filter === 'recent' ? this.dataset.scopeRecent : this.dataset.scopeAll;
        this.querySelector('[data-reviews-status]').textContent = this.dataset.statusTemplate.replace('__FILTER__', button.textContent.trim());
      };
      this.addEventListener('click', this.onClick);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting && !entry.target.hidden) {
              this.mount(entry.target);
              this.observer.unobserve(entry.target);
            }
          });
        }, {rootMargin:'500px 0px'});
        this.groups.forEach(group => this.observer.observe(group));
      } else this.groups.filter(group => !group.hidden).forEach(group => this.mount(group));
    }
    async mount(group) {
      const host = group.querySelector('[data-widget-host]');
      if (host.dataset.mounted) return;
      host.dataset.mounted = 'pending';
      const loading = host.querySelector('[data-widget-loading]');
      loading.hidden = false;
      try {
        await trustpilotReady();
        if (!this.isConnected) return;
        if (!/^[a-f0-9]{24}$/.test(this.dataset.widgetTemplate) || !/^[a-f0-9]{24}$/.test(this.dataset.businessUnit)) throw new Error('Invalid widget');
        const widget = document.createElement('div');
        widget.className = 'trustpilot-widget';
        Object.assign(widget.dataset, {locale:this.dataset.locale,templateId:this.dataset.widgetTemplate,businessunitId:this.dataset.businessUnit,styleHeight:window.matchMedia('(max-width:749px)').matches?'2600px':'1500px',styleWidth:'100%',theme:'light',stars:host.dataset.stars,reviewDisclaimer:'true'});
        const link = group.querySelector('.reviews-group-heading a').cloneNode(true);
        link.textContent = 'Trustpilot';
        widget.append(link);
        host.append(widget);
        window.Trustpilot.loadFromElement(widget, true);
        host.dataset.mounted = 'true';
        loading.hidden = true;
        const labelFrame = () => {
          const frame = widget.querySelector('iframe');
          if (frame) { frame.title = host.dataset.frameTitle; return true; }
          return false;
        };
        if (!labelFrame()) {
          const observer = new MutationObserver(() => { if (labelFrame()) observer.disconnect(); });
          observer.observe(widget, {childList:true});
          this.frameObservers ??= [];
          this.frameObservers.push(observer);
        }
      } catch {
        loading.hidden = true;
        host.dataset.mounted = 'failed';
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.frameObservers?.forEach(observer => observer.disconnect());
      this.removeEventListener('click', this.onClick);
      this.initialized = false;
    }
  }
  if (!customElements.get('dm-reviews-page')) customElements.define('dm-reviews-page', ReviewsPage);
})();
